import React from 'react';
import { useSelector } from 'react-redux';
import { QUESTION_STATUS } from '@model';

function TopProgressBar(props) {
  const status = useSelector(({ question }) => question.status);
  const QSaccessData = useSelector(({ question }) => question.QSaccessData);
  const newStatus = {};
  Object.keys(QSaccessData).forEach((section) => {
    if (!QSaccessData[section]?.disabled) {
      newStatus[section] = status[section]?.filter(
        (e) => e !== QUESTION_STATUS.NotApplicable,
      );
    }
  });

  const total = Object.values(newStatus).reduce((result, item) => {
    if (!Array.isArray(item)) {
      return result;
    }
    return [...result, ...item];
  }, []);

  const totalCount = total.length;
  const finishedCount = total.filter(
    (item) => item === QUESTION_STATUS.Finish,
  ).length;
  return (
    <div className="top-progress-bar">
      <div>
        {finishedCount}/{totalCount} Completed
      </div>
      <div className="progress-bar-wrapper">
        <span style={{ width: `${(finishedCount / totalCount) * 100}%` }} />
      </div>
    </div>
  );
}

TopProgressBar.propTypes = {};

export default TopProgressBar;
